// extracted by mini-css-extract-plugin
module.exports = {"caixa":"header-module--caixa--3oD0e","navList":"header-module--navList--3GS7b","navItem":"header-module--navItem--3mSSO"};